<template>
    <div class="records">
        <el-timeline :style="tableStyle" v-if="recrodList.length > 0">
            <el-timeline-item v-for="(item, index) in recrodList" :key="index"
                :timestamp="item.created | filterTime('YYYY-MM-DD HH:mm:SS')" placement="top">
                <div class="records-item-content">
                    <div style="color:#888;">{{ item.operator }}</div>
                    <div style="margin-top: 8px;">{{ item.handlingRecord }}</div>
                    <div style="margin-top: 8px;">
                        <el-image 
                            v-for="(pathItem, index ) in item.recordUrl" 
                            :key="index" 
                            style="width: 30px; height: 30px; margin-right: 8px;" 
                            fit="cover" 
                            :src="pathItem" 
                            :preview-src-list="item.recordUrl" 
                            :initial-index="index"></el-image>
                    </div>
                </div>
            </el-timeline-item>
        </el-timeline>
        <div v-else class="flex-center">
            <el-empty description="暂无记录"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: 'orderRecord',
    props: {
        tableStyle: {
            type: String,
            default: () => {
                return 'height: calc(100vh - 144px)'
            }
        },
        id: {
            type: [String, Number],
            default: () => {
                return ''
            }
        }
    },
    watch: {
        id: {
            handler(val) {
                if (!val) return
                this.getHandleList()
            },
            immediate: true
        }
    },
    created() {

    },
    data() {
        return {
            recrodList: []
        }
    },
    methods: {
        async getHandleList() {
            let url = "/api/v1/manage/hitchRide/work/handling/record"
            let { code, data } = await this.$axios.get(url, {
                workId: this.id
            })
            if (code == 1) {
                this.recrodList = data.reverse().map(item => {
                    return {
                        ...item,
                        recordUrl: item.file ? item.file.split(',').map(path => this.mixinQiniuImg(path)) : []
                    }
                });
            }
        },
    }
}
</script>

<style lang="less" scoped>
.records {
    padding-left: 170px;
    /deep/ .el-timeline{
        height: auto !important;
    }

    /deep/ .el-timeline-item__timestamp.is-top {
        position: relative;
        left: -170px;
    }

    .records-item-content {
        position: relative;
        top: -24px;
    }
}
</style>